import ReactECharts from "echarts-for-react";
import { getOption } from "./chartOption";
import { useEffect, useState } from "react";
import { getUsage } from "../service";
import dayjs from "dayjs";
import { showToast } from "ui/components/common";
export default function UsageCharts({ month, curClass, color }) {
  const [option, setOption] = useState({});
  useEffect(() => {
    const startTime = dayjs()
      .set("month", month - 1)
      .startOf("month");
    const endTime = dayjs()
      .set("month", month - 1)
      .endOf("month");
    getUsage(
      curClass.value,
      startTime.format("YYYYMMDD"),
      endTime.format("YYYYMMDD"),
    ).then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to fetch usage data");
      } else {
        const modifiedData = data.data.items.map((item) => ({
          day: item.day,
          usedCredit: Number(item.usedCredit),
        }));
        const _option = getOption(modifiedData, color, curClass);
        setOption(_option);
      }
    });
  }, [month]);
  return (
    <div
      style={{
        width: "100%",
        height: "321px",
        backgroundColor: "rgba(250, 250, 250, 1)",
        padding: "24px",
        borderRadius: "24px",
        marginTop: "16px",
      }}
    >
      {option && <ReactECharts option={option} />}
    </div>
  );
}
